import { isEmpty } from "lodash";
import React, { Fragment } from "react";
const RenderOddsHome = ({ matchOdds, res }) => {
  const getRunnerOdds = (selectionId, oddsArray) => {
    const odds = oddsArray?.filter((o) => o.ri === selectionId);

    const back =
      odds
        ?.filter((o) => o.ib === true && o.rt > 0)
        ?.sort((a, b) => b.rt - a.rt)[0]?.rt || "--";

    const lay =
      odds
        ?.filter((o) => o.ib === false && o.rt > 0)
        ?.sort((a, b) => a.rt - b.rt)[0]?.rt || "--";

    return { back, lay };
  };

  const team1 = res?.runners[0];
  const draw = res?.runners?.find((r) => r.RunnerName === "The Draw");
  const team2 = res?.runners?.find(
    (r) => r.RunnerName !== team1.runner && r.RunnerName !== "The Draw"
  );
  return (
    <>
      {/* VISIT TEAM */}
      <dd className="col-visit">
        {(() => {
          const { back, lay } = getRunnerOdds(
            team1?.SelectionId,
            matchOdds?.rt
          );
          return (
            <>
              <a className="btn-back">{back}</a>
              <a className="btn-lay">{lay}</a>
            </>
          );
        })()}
      </dd>

      {/* DRAW — always render */}
      <dd className={`col-draw ${isEmpty(draw) ? "disabled" : ""}`}>
        {!isEmpty(draw) ? (
          (() => {
            const { back, lay } = getRunnerOdds(
              draw?.SelectionId,
              matchOdds?.rt
            );
            return (
              <>
                <a className="btn-back">{back}</a>
                <a className="btn-lay">{lay}</a>
              </>
            );
          })()
        ) : (
          <>
            <a className="btn-back">--</a>
            <a className="btn-lay">--</a>
          </>
        )}
      </dd>

      {/* HOME TEAM */}
      <dd className="col-home">
        {team2 ? (
          (() => {
            const { back, lay } = getRunnerOdds(
              team2?.SelectionId,
              matchOdds?.rt
            );
            return (
              <>
                <a className="btn-back">{back}</a>
                <a className="btn-lay">{lay}</a>
              </>
            );
          })()
        ) : (
          <>
            <a className="btn-back">--</a>
            <a className="btn-lay">--</a>
          </>
        )}
      </dd>
    </>
  );
};

export default RenderOddsHome;
